import { Store } from "store/defaultState";

export const configSelector = (state: Store) => state.web3Config.config;